export default __webpack_public_path__ + "static/media/calendar.d052eef2.svg";